module.exports = __webpack_public_path__ + "img/glogo29.a2c20044.png";